import { useEffect, useState } from "react";

import { STORAGE_KEYS } from "@shared/constants/storageKeys";
import { parseStoredProjectAssignments } from "../lib/projectAssignments";
import type { ProjectWithAssignment, UnmatchedAssignment } from "../lib/projectAssignments";

interface StoredProjectAssignmentsState {
  all: ProjectWithAssignment[];
  staffing: ProjectWithAssignment[];
  projects: ProjectWithAssignment[];
  unmatched: UnmatchedAssignment[];
  supportReference: string | null;
}

const EMPTY: StoredProjectAssignmentsState = {
  all: [],
  staffing: [],
  projects: [],
  unmatched: [],
  supportReference: null,
};

// Lee los proyectos asignados que ManagementHourPage dejó en localStorage y los
// separa en staffings y proyectos. Centraliza el split que antes estaba copiado
// en tres diálogos. Reactivo al flag `open` del diálogo que lo consume.
//
// El parseo tolera tanto el envelope actual como el array sin envolver que dejaba la
// versión previa del endpoint (ver lib/projectAssignments): un browser puede
// seguir teniendo esa forma vieja guardada justo después del deploy.
export const useStoredProjectAssignments = (open: boolean) => {
  const [assignments, setAssignments] = useState<StoredProjectAssignmentsState>(EMPTY);

  useEffect(() => {
    if (!open) return;
    const { projects: stored, unmatched, supportReference } = parseStoredProjectAssignments(
      localStorage.getItem(STORAGE_KEYS.PROJECT_ASSIGNMENTS)
    );
    setAssignments({
      all: stored,
      staffing: stored.filter((item) => item.isStaffing),
      projects: stored.filter((item) => !item.isStaffing),
      unmatched,
      supportReference,
    });
  }, [open]);

  return assignments;
};
